<template>
  <div>
    <a :href="getAPIUrl()">
      <img src="../../../assets/appleWalletbutton.png" alt="appleButton" style="width: 100%;" :style="buttonHeight()"/>
    </a>
  </div>
</template>

<script>
import { getAppleAPIUrl } from "../../../api/services/walletService.js";
export default {
  name: "ApplePay",
  props: {
    userId: String,
    storeId: String
  },
  methods: {
    getAPIUrl() {
      return getAppleAPIUrl(this.userId, this.storeId);
    },
    buttonHeight() {
      if (this.isMobile()){
        return [];
      }else {
        return [{'height': '38px'}];
      }
    }
  }
};
</script>
